// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// import { connectAuthEmulator } from "firebase/auth"; // eslint-disable-next-line no-unused-vars
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBNAFM0QqgmdqFcYUTTKPYPpvXKGUAKAVM",
//   authDomain: "airsmart-2695a.firebaseapp.com",
//   projectId: "airsmart-2695a",
//   storageBucket: "airsmart-2695a.firebasestorage.app",
//   messagingSenderId: "438636042629",
//   appId: "1:438636042629:web:4d9f85a01702b29cf60cec",
//   measurementId: "G-75K5XY0792",
// };
const firebaseConfig = {
  apiKey: "AIzaSyBvyJlpHyHbDfj_Awn-ilKuHFlV5FddDTU",
  authDomain: "airsmart2.firebaseapp.com",
  projectId: "airsmart2",
  storageBucket: "airsmart2.firebasestorage.app",
  messagingSenderId: "257199864317",
  appId: "1:257199864317:web:e9d67c47e1af806c6a4194",
  measurementId: "G-6BH6MDFJKQ",
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
export { auth, analytics, app, db };
